// extracted by mini-css-extract-plugin
module.exports = {"tag-line":"TagLine_tag-line__XpKd4","tagLine":"TagLine_tag-line__XpKd4","tag-line-item":"TagLine_tag-line-item__BUf5q","tagLineItem":"TagLine_tag-line-item__BUf5q"};